import { getLicensePlatesToExclude } from "../services/licensePlatesService";
import { createContext, useState } from "react";

const LicensePlatesContext = createContext({
    licensePlatesToExclude: []
});

export const LicensePlatesProvider = ({ children }) => {
    const [licensePlatesToExclude, setLicensePlatesToExclude] = useState([]);

    const fetchLicensePlatesToExclude = async () => {
        try {
            console.log("fetching license plates")
            const data = await getLicensePlatesToExclude();
            setLicensePlatesToExclude(data || []);
        } catch (error) {
            console.error("Error fetching license plates:", error);
        }
    };

    const contextValue = {
        licensePlatesToExclude,
        fetchLicensePlatesToExclude
    };

    return (
        <LicensePlatesContext.Provider value={contextValue}>
            {children}
        </LicensePlatesContext.Provider>
    );
};

export default LicensePlatesContext;